







import { Vue, Component, Prop } from 'vue-property-decorator';
import BallotCheckIcon from './BallotCheckIcon.vue';
import WhiteBlueButton from '../../../components/button/WhiteBlueButton.vue';
@Component({ components: { BallotCheckIcon, WhiteBlueButton } })
export default class LessonStateButton extends Vue {
  css_class = {
    'd-block': true,
    'px-3': true,
    'py-1': true,
    'w-1105rem': true,
    'rounded-xl': true,
    'bw-02r': true,
  };
}
